import React from 'react'
import styled from 'styled-components';
import TagsImg from '../../assets/tags.png'
import Start1Img from '../../assets/start1.png'
import Start2Img from '../../assets/start2.png'
import Start3Img from '../../assets/start3.png'

const BlockStyle = styled.div`
  width: 100%;
  box-shadow: 8px 8px 30px -5px rgba(13, 64, 152, 0.16);
  border-radius: 16px;
  transition: all .3s;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  flex-direction:${({reverse}) => reverse ? 'row-reverse' : 'row'};
  &:hover {
    box-shadow: 8px 8px 30px -5px rgba(13, 64, 152, 0.26);
  }
  .cont {
    color: #666666;
    padding-left: 40px;
    width: 55%;
    transform: ${({reverse}) => reverse ? 'translateX(-40px)' : 'translateX(0)'}; ;
    .title {
      margin-left: -20px;
      display: flex;
      align-items: center;
      color: #3D6DE5;
      h3 {
        margin-bottom: 0;
      }
      img {
        margin-right: 10px;
        height: 40px;
        margin-bottom: 0;
      }
    }
    .desc {
      color: #333333;
      font-size: 24px;
      line-height: 32px;
      margin-bottom: 10px;
      font-weight: 500;
    }
    .list {
      list-style: disc;
      font-size: 19px;
      line-height: 24px;
      li {
        margin-bottom: 6px;
      }
    }
    .details {
      list-style: disc;
      font-size: 19px;
      line-height: 24px;
      background-color: rgba(61, 109, 229, 0.05);
      border-radius: 10px;
      padding: 20px 20px 20px 40px;
      margin-bottom: 0;
      .subname {
        margin-left: -20px;
        color: #333333;
        font-weight: 500;
      }
    }
  }
  .img-box {
    width: 38%;
    img {
      width: 100%;
    }
  }
  @media (max-width: 768px) {
    display: block;
    .cont {
      width: 100%;
      padding-left: 30px;
      transform: translateX(0);
      padding-top: 15px;
      line-height: 24px;
      .desc {
        font-size: 22px;
        line-height: 26px;
      }
      .list {
        font-size: 16px;
        padding-right: 10px;
      }
      .details {
        font-size: 16px;
        transform: translateX(-15px);
      }
    }
    .img-box {
      margin: auto;
    }
  }
`;

export default function GrantItem(props) {
  return (
    <>
      <BlockStyle key={0}>
        <div className="cont">
          <div className="title">
            <div><img src={TagsImg} alt="" /></div>
            <h3 className="h3">Grant for events & creation works</h3>
          </div>
          <div className="desc">academic research, model design, NFT artwork, marketing activities</div>
          <ul className="list">
            <li>In each project, the hardcap and softcap amount need to be set manually.</li>
            <li>If the project is successfully launched, the project initiator can use the corresponding TRIAS token to organize the related activities. Meanwhile, the Trias community should be notified of the progress. If the project fails to launch, the TRIAS token will be returned to the contributors.</li>
          </ul>
          <ul className="details">
            <div className="subname">Details：</div>
            <li>Click "<a rel="noreferrer" href="https://forms.gle/Zt5QRYRDz5TYmtjD9" target="_blank">Create a grant</a>"</li>
            <li>Fill out all the information about your grant;</li>
            <li>Wait for Trias Grant's confirmation;</li>
            <li>Start the grant.</li>
          </ul>
        </div>
        <div className="img-box">
          <img src={Start1Img} alt="" />
        </div>
      </BlockStyle>
      <BlockStyle key={1} reverse>
        <div className="cont">
          <div className="title">
            <div><img src={TagsImg} alt="" /></div>
            <h3 className="h3">Grant for blockchain projects</h3>
          </div>
          <div className="desc">innovation projects based on Trias ecology</div>
          <ul className="list">
            <li>In each project, the hardcap and softcap amount need to be set manually.</li>
            <li>If the project is successfully launched, the project initiator receives TRIAS token and issues a new token to the donors according to a certain proportion (1: x) to organize relevant activities. Meanwhile, the Trias community should be informed of the progress. If the project fails to launch, the token raised needs to be returned to contributors.</li>
          </ul>
          <ul className="details">
            <div className="subname">Details：</div>
            <li>Submit the grant proposal to Trias DAO;</li>
            <li>Get the approval from Trias DAO;</li>
            <li>Win the opportunity of Trias Grant;</li>
            <li>Start the grant.</li>
          </ul>
        </div>
        <div className="img-box">
          <img src={Start2Img} alt="" />
        </div>
      </BlockStyle>
      <BlockStyle key={2}>
        <div className="cont reverse">
          <div className="title">
            <div><img src={TagsImg} alt="" /></div>
            <h3 className="h3">Grant for DAO Governance</h3>
          </div>
          <div className="desc">proposals for Trias development</div>
          <ul className="list">
            <li>TRIAS token holders</li>
            <li>The voting method is Quadratic Voting, which is 1 vote for 1 point, 100 votes for 10 points. If five people are voting in the project, and the number of votes is 1, 16, 100, 400, 900 respectively, then the final amount of voted TRIAS token will be 4225.</li>
          </ul>
          <ul className="details">
            <div className="subname">Details：</div>
            <li>Click "<a rel="noreferrer" href="https://forms.gle/Zt5QRYRDz5TYmtjD9" target="_blank">Create a grant</a>"</li>
            <li>Fill out all the information about your grant;</li>
            <li>Wait for Trias Grant's confirmation;</li>
            <li>Start the grant.</li>
          </ul>
        </div>
        <div className="img-box">
          <img src={Start3Img} alt="" />
        </div>
      </BlockStyle>
    </>
  )
}
